import React from 'react';
import { getUsers } from '../utils/storage';

function GiveawayCard({ giveaway, onEnter, formatTimeRemaining, currentUser, onViewProfile }) {
  // Get user's entry count for this giveaway
  let userEntryCount = 0;
  if (currentUser && currentUser.entries) {
    const giveawayId = giveaway.id.toString();
    const userEntry = currentUser.entries[giveawayId];
    if (userEntry) {
      const expiresAt = new Date(userEntry.expiresAt);
      if (expiresAt > new Date()) {
        userEntryCount = userEntry.count || 0;
      }
    }
  }

  return (
    <div className="giveaway-card">
      <h3>{giveaway.title}</h3>
      <div className="prize">Prize: {giveaway.prize}</div>
      <div className="description">{giveaway.description}</div>
      <div className="ends">Ends in: {formatTimeRemaining(giveaway.endsAt)}</div>
      <div className="participants">{giveaway.participants.toLocaleString()} participants</div>
      {currentUser && userEntryCount > 0 && (
        <div className="user-entries" style={{ 
          color: '#10de82', 
          fontSize: '0.9rem', 
          marginBottom: '0.5rem',
          fontWeight: 600
        }}>
          Your entries: {userEntryCount}
        </div>
      )}
      {giveaway.createdBy && (
        <div className="giveaway-creator" style={{ 
          fontSize: '0.85rem', 
          color: '#aab1c7',
          marginBottom: '0.5rem'
        }}>
          Created by: {giveaway.createdBy}
          {onViewProfile && currentUser && (
            <button 
              className="view-profile-link"
              onClick={(e) => {
                e.stopPropagation();
                // Find user ID by username
                const users = getUsers();
                const creator = users.find(u => u.discordUsername === giveaway.createdBy);
                if (creator) {
                  onViewProfile(creator.id);
                }
              }}
              style={{
                marginLeft: '0.5rem',
                background: 'none',
                border: 'none',
                color: '#6361e7',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
            >
              View Profile
            </button>
          )}
        </div>
      )}
      <button className="enter-btn" onClick={onEnter}>
        {currentUser ? 'Enter Giveaway' : 'Login to Enter'}
      </button>
    </div>
  );
}

export default GiveawayCard;

